import { render } from "./articleList.vue?vue&type=template&id=2ccc93f2"
import script from "./articleList.vue?vue&type=script&lang=js"
export * from "./articleList.vue?vue&type=script&lang=js"

import "./articleList.vue?vue&type=style&index=0&id=2ccc93f2&lang=css"

import exportComponent from "C:\\Project\\VuePro\\guifanrenrenxing\\guifanrenrenxing-index\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__